export const nextSnack = (state) => {
  return state.queueBigSnackbar || []
}

export const disclaimer = (state) => {
  return state.disclaimer.data || {}
}

export const disclaimerImg = (state) => {
  return state.disclaimer.dataImg || {}
}

export const disclaimerLoading = (state) => {
  return state.disclaimer.loading
}
export const disclaimerLastUpdate = (state) => {
  return state.disclaimer.lastUpdate
}
export const officeParameters = (state) => {
  return state.officeParameters.data || []
}
export const officeParametersLoading = (state) => {
  return state.officeParameters.loading
}
export const officeParametersLastUpdate = (state) => {
  return state.officeParameters.lastUpdate
}

export const profissionaisPermissao = (state) => {
  return state.profissionaisPermissao.data || []
}
export const profissionaisPermissaoLoading = (state) => {
  return state.profissionaisPermissao.loading
}
export const profissionaisPermissaoLastUpdate = (state) => {
  return state.profissionaisPermissao.lastUpdate
}

export const internalUsers = (state) => {
  return state.internalUsers.data || []
}
export const internalUsersLoading = (state) => {
  return state.internalUsers.loading
}
export const internalUsersLastUpdate = (state) => {
  return state.internalUsers.lastUpdate
}

export const previousPage = (state) => {
  return state.previousPage
}
export const fullDataClient = (state) => {
  return state.fullDataClient.data || []
}
export const fullDataClientLoading = (state) => {
  return state.fullDataClient.loading
}
export const fullDataClientLastUpdate = (state) => {
  return state.fullDataClient.lastUpdate
}
